<template>
    <b-modal
        id="create-folder-modal"
        title="New Folder"
        v-model="show"
        @shown="$emit('shown')"
        @hidden="$emit('hidden')"
    >
        <slot></slot>
    </b-modal>
</template>

<script>
export default {
    name: "CreateFolderModal",
    props: {
        isShown: Boolean
    },
    data() {
        return {
            show: this.isShown
        };
    }
}
</script>

<style scoped>

</style>
